import { Link, useParams } from "react-router-dom";
import { POLICIES, POLICY_UPDATED } from "@/policies";

const Text = ({ children }) =>
  children.split(/(\[TO CONFIRM[^\]]*\])/).map((part, i) =>
    part.startsWith("[TO CONFIRM") ? (
      <mark key={i} className="policy-todo">
        {part}
      </mark>
    ) : (
      part
    ),
  );

export default function PolicyPage() {
  const { slug } = useParams();
  const policy = POLICIES[slug] || POLICIES.terms;
  return (
    <main className="policy-page" data-testid={`policy-page-${slug}`}>
      <p className="eyebrow red">THE TYRE CO / POLICIES</p>
      <h1 data-testid="policy-title">{policy.title}</h1>
      <p className="policy-intro">{policy.intro}</p>
      {policy.sections.map(([heading, paras]) => (
        <section key={heading} className="policy-section">
          <h2>{heading}</h2>
          {paras.map((p, i) =>
            p.startsWith("~") ? (
              <p key={i} className="policy-fineprint" data-testid="policy-address">
                {p.slice(1)}
              </p>
            ) : (
              <p key={i}>
                <Text>{p}</Text>
              </p>
            ),
          )}
        </section>
      ))}
      <p className="policy-updated">{POLICY_UPDATED}</p>
      <nav className="policy-nav">
        {Object.entries(POLICIES).map(([key, p]) => (
          <Link key={key} to={`/policies/${key}`} className={key === slug ? "active" : ""} data-testid={`policy-nav-${key}`}>
            {p.title}
          </Link>
        ))}
      </nav>
    </main>
  );
}
